import React from 'react';

export default function BookingSummary({
    selectedPackage,
    selectedAddOns = [],
    totalPriceCents,
    totalDurationMinutes,
    location,
    date,
    slot,
    promoCode,
    onPromoCodeChange,
    onApplyPromo,
    promoDiscount,
    promoError,
    promoApplied
}) {
    return (
        <div className="wizard-step">
            <h2>Review & Confirm</h2>

            <div className="summary-card">
                <div className="summary-section">
                    <h3>Your Package</h3>
                    <div className="summary-package">
                        <span className="pkg-name">{selectedPackage?.name}</span>
                        <span className="pkg-price">${(selectedPackage?.priceCents / 100).toFixed(2)}</span>
                    </div>
                    <p className="pkg-desc">{selectedPackage?.description}</p>

                    {selectedAddOns.length > 0 && (
                        <div className="summary-addons">
                            <h4>Add-Ons</h4>
                            {selectedAddOns.map((a, i) => (
                                <div key={i} className="addon-line">
                                    <span>+ {a.name}</span>
                                    <span>+${(a.priceCents / 100).toFixed(2)}</span>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Promo Code Section */}
                    <div className="promo-section" style={{ marginTop: '1rem', padding: '1rem', background: '#f5f5f5', borderRadius: '8px' }}>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <input
                                type="text"
                                placeholder="Promo Code"
                                value={promoCode || ''}
                                onChange={(e) => onPromoCodeChange(e.target.value)}
                                disabled={promoApplied}
                                style={{ flex: 1, padding: '8px' }}
                            />
                            <button
                                onClick={onApplyPromo}
                                disabled={promoApplied || !promoCode}
                                className="btn btn-secondary"
                                style={{ padding: '8px 16px' }}
                            >
                                {promoApplied ? '✓' : 'Apply'}
                            </button>
                        </div>
                        {promoError && <p style={{ color: 'red', fontSize: '0.9rem', marginTop: '4px' }}>{promoError}</p>}
                        {promoApplied && <p style={{ color: 'green', fontSize: '0.9rem', marginTop: '4px' }}>Promo code applied!</p>}
                    </div>

                    {promoDiscount > 0 && (
                        <div className="summary-total" style={{ marginTop: '0.5rem', color: 'green' }}>
                            <span>Discount:</span>
                            <span>-${(promoDiscount / 100).toFixed(2)}</span>
                        </div>
                    )}

                    <div className="summary-total">
                        <strong>Total:</strong>
                        <strong>${(totalPriceCents / 100).toFixed(2)}</strong>
                    </div>
                    <div className="summary-duration">
                        <span>⏱ {totalDurationMinutes} minutes</span>
                    </div>
                </div>

                <div className="summary-section">
                    <h3>Appointment</h3>
                    <p><strong>Date:</strong> {date}</p>
                    <p><strong>Time:</strong> {slot}</p>
                    <p><strong>Location:</strong> {location?.address}</p>
                    {location?.accessInstructions && (
                        <p><strong>Access:</strong> {location.accessInstructions}</p>
                    )}
                </div>
            </div>

            <div className="expectations-box">
                <h4>Payment Expectations</h4>
                <p>Payment is collected directly by your Artisan upon completion of your service. We accept <strong>Cash</strong> or <strong>Interac e-Transfer</strong>.</p>
            </div>
        </div>
    );
}
